var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#165d31",
    d: "M-2.7 0h60v40h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.5 11.3c-.1 1-.2 2.6.6 2.8 1 0 .4-1.6.8-2q.1-.2.2 0v1.5q.1.7.5.8.4 0 .5.2l.2 2.5s.5.2.6-1.4l-.1-1.9q0-.3.4-.1.3.4.7.3 1-.2 1-.9t-.3-1.3v-.4q.1.3.2 0 0-.5-.5-.7-.4-.3-.6.2 0 .7.5 1.4l.1.7-.5-.1-.4-.4v-1.2l-.4-.6h-.4c-.2.4 0 1.2 0 1.5l.3.5q0 .3-.3 0l-.2-1.4c0-.4 0-1.1-.3-1.3q-.3-.2-.4 0v1.1l.3 1.7c0 .8-.5.3-.5 0q.2-.8 0-1.6 0-.2-.3-.2-.4 0-.7 1.1l-.1.7c0 .3-.3.6-.5 0-.1-.6-.2-1.7-.4-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 15.2-2.4 1.2c0-.6 1.1-1.6 2-1.6.5 0 .3.2.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 16c-1.3 3.4 3.1 3.8 3.6 0h.3c-.1 3.4-3.4 3.6-4 2.6l-.2-1.2q-.2-.8-.5.3v.8c.2 2.7 4.4 1.5 5.1-.7.4-1.2 0-2 .1-2 .5.4 1 0 1.2-.2h.3q.7.3 1-.3l.1-1.3-.4.3-.1.3q-.2.3-.3 0-.2-.8-.7.2-.4.3-.6 0 0-.7-.5-.3l-.4-2.9h.5c-.2-.6-.5-1.6-.7-1.7H18q-.4 0-.3.6l.6 4q0 .4-.3.4-.3-.4-1-.6-.6.1-.8.8v1q.5.4.9.2l.5-.2s0 .8-1.1 1.4q-1.1.6-1.5-.2c-.2-.3 0-1.7-.5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.2 12.5c.3 0 1.5-1.5 1.5-1.5l-.2-.2v-.2q.5-.3.1-.7h-.7q-.3.3 0 .7c0 .1.3.3.1.4-.5.5-1.9 1.5-1.7 1.5zm-7.6 5c-.4.8-.5 2-.2 2.3l.5.2q.5-.5.4-1-.1-.2-.3 0c-.2.4-.3 0-.3-.1zm20.1-1.1q-.7-1.7-1.2-2.3-1-1.6-2-2.8c-.5-.6.8.2-.1-1l-.7-.6c-.2 0-.6-.3-.6 0v.8l.4.5q2.4 3.3 4.2 6.8c.2-.1.1-1.3 0-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.7 19.6c0 .1.3.6.7.6q.9 0 1.8-1.5l.4-1a25 25 0 0 0-.4-6.1l.2-.2L33 10q0-.4-.3 0l-.2 1 .6 6.5-.1.6q-1 1-2.2 1.5m9.1 0q-.6.5 0 .6c.6 0 1.4 0 2-1q.3-.4.3-1.2.1-2.7-.4-5.5v-.6l.3-.1c.1-.1-.6-1-.8-1.4q0-.4-.3 0-.2.6-.1 1c.4 2.5.6 4.3.7 6.5q0 .3-.2.5l-.6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.2 17.5V16q0-.6-.2-1t-.2-1l-.1-1.2V12h.2c0-.2-.4-1.5-.7-1.9l-.4.2q-.2.3 0 1 .7 3.7.7 7.2c0 .2.7-.6.7-1m-3.6-3.1c-.3 0-1-.7-1-1V13q0-.2.4 0v.1h.3v-.3q.1-.6.6-.2l.2.6h-.3l-.1.3zM31 18v-2.6l-.3-3.5c-.1-.6.3.1.2-.3q-.2-.8-.9-1.7 0-.3-.3 0c-.3.6 0 1 0 1.4a25 25 0 0 1 .6 7.6q.4 0 .7-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.2 16.9c-.5-1-1.3-1.9-1.5-2.3l-2.3-3c-.7-.6.3 0-.1-.6l-.8-.8c-.2 0-.3-.3-.3 0v1l.2.5q2.5 2.8 4.8 6.6c.2-.1.2-1.3 0-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#165d31",
    d: "m17 15.2-.2.3h.5v-.2q-.1-.4-.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35 28.3 1.8.1h.8c.8-.1.8 1.1.8 1.1 0 .8-.3.8-.6.9q-.2 0-.5-.3h-2.2q0 .3-.3.2-.4-.2-.3-.8v-.3l-8.7-.2-6.7.2q-1.8.1-2.8-1h4L25 28q4.8 0 9.6.3-.5-.5.1-.8l.2.2c.4 0 .2.5.1.6M22 10.6c-.4 1.4.3 2.9.9 2.7q.6.1.8-1.3.1-.4.2-.2c0 1.1 0 1.3.4 1.7.6.4 1 0 1.1 0l.5-.5q.1-.2.4 0 0 .2.4.5.6.1 1-.2l.3-.5q.2-.2.3 0v.3h.2c.3-.1.6-.8.6-.8q0-.3-.3-.2l-.2.2q-.3.1-.6-.1 0-.5-.3-1-.1-.2 0-.4h.4q-.1-.5-.5-1-.2-.2-.6 0l-.2.5.1.7q.4.5.4 1.4 0 .2-.5.2c-.1 0-.3 0-.4-.9q0-1-.3-2 0-.4-.4 0c0 .2-.3.4-.1 1q.3.7.1 1.4 0 .3-.3.4-.3.3-.6.1l-.3-.5v-1.6q-.4-.3-.6-.1-.6.8-.9 1.8-.2.6-.4.2c-.2-.3-.2-2.1-.5-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.5 13.6c.3-.2.2-.3.5 0q.6 1.3.7 2.5 0 .3.2.3c0-.5 1.2-1.1 2.2-1.2q.2-.2.1-.5 0-1 1-1.2 1 .2 1 1.1c-.2 1.2-1.4 1.4-2 1.5q-.3 0 0 .1H30l.2.1-.2.2q-.3.4-.3 1l-2.6.4q-.5.3-.4.6c0 .3.8.6.8.6q.3 0 0 .6-2.2 0-3-1.5l-.2.2q-.8 1.1-2 1.6-1 .3-1.4-.4l-.3-.5c-.3.1-2.8 1.2-2.5.7q1-1 2.7-1.8c0-.2.2-1 .5-1.2v.8s1.2-1 1.3-1.3v-.6l-.6-.8q0-.7.2-1h.6l.5 1h-.4l.3.6v1.3q-.9 1.3-1.8 1.8l.2.4q.1.2.7 0 1.2-.6 1.8-1.8l-.2-1.7c-.3-.5-.5-1.3-.5-1.3zm-7.4-3c.3.1 1 0 .9-.5V10q-.2-.2-.3 0v.2l-.2-.1v-.2h-.1l-.1.2h-.1l-.1-.1q-.4 0-.3.2 0 .2.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.7 14.7c.3.1 1.1 0 1-.5V14q-.3-.2-.4 0v.2l-.1-.1v-.2H26v.2h-.2v-.2h-.1q-.2 0-.2.3t.2.5m5.6-1.7q.8.2 1-.5v-.2q-.2-.2-.4 0v.2l-.1-.1v-.2h-.2v.2h-.2v-.2h-.1q-.2 0-.2.3t.2.5m3 4.2c-.6.7-.4 1.7-.2 2q.1.5.7.8.5.2.7-.1c.3-.4.3-1.3.5-1.4q.3-.5.5-.1l.5.4q.5.4 1 0 .5-.1.6-.7c.2-.4.1-2.4 0-3.6l-.3-1.7v-1h.2v-.2l-.7-1.5h-.3l-.1.5v1l.4 1.8.2 3.5q0 .9-.3 1-.1.1-.4 0l-.6-.7q-.3-.3-.6 0c-.4.4-.6 1.3-1 1.8q-.1.4-.5 0c-.7-.9-.3-2.1-.4-1.8M31.4 10q.5.3.4 1t-.3.7V11l-.5-.7q0-.3.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.2 17.6V16l-.6-4c-.2-.6.4 0 .3-.4l-.8-1.5q0-.3-.2 0-.3.8-.2 1.5.9 3.6.9 7 .4-.1.6-1m5-6.7c.3.1.5.9.4 1.1q0 .7-.3.8V12l-.4-.8q0-.3.3-.3m-20 5.3c.3.1.5.7.4.8q0 .5-.3.6V17l-.4-.5q0-.4.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#165d31",
    d: "M26.5 17q.6.1.2.4-.6 0-.7.7c.2.6-.1.4-.3.3q-.5-.1-.8-1.2 0-.2.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.4 9.7c.4.1.4.7.4.9q-.1.6-.3.5v-.5c-.1-.2-.5-.5-.4-.6q0-.3.3-.3m7.5 2.6q-.4.4-.3 1 .4.2.5.1c.3 0 .5-.5.5-.5q.1-.2-.4.1l-.1-.1v-.4q0-.2-.2-.2M23 9.5q-.4.2-.5.8v.3h.5l.1-.3c0-.2-.2.1-.2-.1l.3-.6q0-.2-.2-.1m1.7.3-.1.9q0 .4.3 0l.2-1q0-.5-.4.1M36 15.5l1.6-1.2v.6L36 16q-.2-.2 0-.5m1.4 0c.3 0 .4.9.3 1q0 .8-.3.8v-.7q-.3-.5-.3-.8t.3-.4m-9 3.3.4-.3h.3l-.1.5.2.1q.3-.2.7-.2.3.2 0 .4-.5 0-.9.3h-.3v-.3q0-.3-.2-.3h-.2zm10.6.5v.3l-.3.2v.3q.8-.2 1-.4v-.2h-.2l-.1-.2v-.4h-.5l-.1.2q0 .2.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#165d31",
    d: "M28.3 14.8H28q-.2 0-.2-.3h.3zm-7-4.2-.2-.1v-.2l.3.1zm13.8 18.7h2.1q.2.3 0 .4h-.6c0-.2-.6-.2-.6 0h-1z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.440d675a48084185d0897e3baf33fd18.svg";
export { ForwardRef as ReactComponent };